import { useSyncExternalStore } from 'react';

/** Opening Clu as the tabbed sidebar's chats open it (see useChatTabs). */
export interface CluOpener {
  /** Clu with the chat it holds. */
  open: () => void;
  /** A new Clu chat with `text` as its first message. */
  ask: (text: string) => void;
  /** Both open the Clu dock beside the page, as ⌘J does; else /clu. */
  inDock: boolean;
}

/**
 * The tabbed sidebar's way of opening Clu, for surfaces outside it (the ⌘K
 * palette, mounted above the app shell): beside the page in the Clu dock, or
 * on /clu where the dock can't show it. Null while the tabbed sidebar is
 * not mounted or Clu is not available.
 */
let current: CluOpener | null = null;
const listeners = new Set<() => void>();

export function publishCluOpener(opener: CluOpener | null): void {
  if (current === opener) return;
  current = opener;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const read = () => current;
const readOnServer = () => null;

/** The sidebar's Clu opener, or null without the tabbed sidebar. */
export function useCluOpener(): CluOpener | null {
  return useSyncExternalStore(subscribe, read, readOnServer);
}
